<template>
  <div>
    <el-tree
      ref="tree"
      :data="newMenus"
      :default-checked-keys="defaultCheckedKeys"
      node-key="menu_id"
      :props="defaultProps"
      show-checkbox
      :default-expand-all="expandAll"
    />
  </div>
</template>

<script>
import { filterHideMenu } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  props: {
    data: Array,
    treeCheckedKeys: Array,
    rowData: Object,
    expandAll: {
      type: Boolean,
      default: false
    },
    currentRole: Object
  },
  data () {
    return {
      defaultProps: {
        children: 'subset',
        label: 'menu_name'
      },
      defaultCheckedKeys: []
    }
  },
  computed: {
    ...mapGetters(['menus']),
    newMenus () {
      let menus = []
      menus = filterHideMenu(this.$store.getters.menus).filter((v) => v.menu_name)
      return menus
    }
  },
  watch: {
    rowData (newRow) {
      const { is_system, role_name } = this.currentRole
      if (newRow && newRow.role_list) {
        this.$refs.tree.setCheckedNodes(this.getNewCheckedNodes(newRow.role_list) || [])
      } else if (is_system && role_name !== '普通员工') {
        // 默认全选
        this.$refs.tree.setCheckedNodes(this.newMenus)
      } else {
        this.$refs.tree.setCheckedNodes([])
      }
    }
  },
  created () {
    this.defaultCheckedKeys = JSON.parse(JSON.stringify(this.treeCheckedKeys))
  },
  mounted () {},

  methods: {
    filterHideMenu: filterHideMenu,
    getTreeData () {
      var checkedNodes = this.$refs.tree.getCheckedNodes(false, true)
      var checkedKeys = []
      checkedNodes.forEach((item) => {
        if (!item.isChildrenMenu) {
          checkedKeys.push(item.id)
        }
      })
      return checkedKeys
    },
    getNewCheckedNodes (arr) {
      let newArr = []
      arr.forEach((v) => {
        v.subset &&
          v.subset.forEach((item) => {
            newArr.push(item)
          })
      })
      return newArr
    }
  }
}
</script>

<style lang="scss" scoped>
.select-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0;
}
.select-footer {
  padding: 20px 0;
}
.nodata {
  padding: 30px;
  text-align: center;
  color: #666666;
}
.guize-list {
  li {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #f1f1f1;
    padding: 5px 0;
    .avatar-box {
      width: 50px;
    }
    .btn-box {
      width: 86px;
      text-align: center;
    }
    .item {
      flex: 1;
      font-size: 12px;
      .title {
        color: #333;
      }
      .content {
        color: #666666;
        .name {
          color: #333;
          display: inline-block;
          padding: 10px;
        }
      }
    }
  }
}
</style>
